import api from "@/api/axios";
import {
  MateCard,
  InviteInput,
  InviteResponse,
  AcceptInviteResponse,
  HeartbeatResponse,
  MatesWithPending,
  MateLatestWorkoutResponse,
} from "@/types/mateTypes";

export const mateApi = {
  // Get all mates
  getMates: async (): Promise<MateCard[]> => {
    const response = await api.get("/api/mates");
    return response.data;
  },

  // Get mates with pending invites
  getMatesWithPending: async (): Promise<MatesWithPending> => {
    const response = await api.get("/api/mates/with-pending");
    return response.data;
  },

  // Cancel a pending invite
  cancelInvite: async (inviteId: number): Promise<{ success: boolean }> => {
    const response = await api.post(`/api/mates/invites/${inviteId}/cancel`);
    return response.data;
  },

  // Send an invite
  inviteMate: async (input: InviteInput): Promise<InviteResponse> => {
    const response = await api.post("/api/mates/invites", input);
    return response.data;
  },

  // Accept an invite
  acceptInvite: async (token: string): Promise<AcceptInviteResponse> => {
    const response = await api.post(`/api/mates/invites/${token}/accept`);
    return response.data;
  },

  // Reject an invite
  rejectInvite: async (token: string): Promise<InviteResponse> => {
    const response = await api.post(`/api/mates/invites/${token}/reject`);
    return response.data;
  },

  // Mark all mates as read
  markAllRead: async (): Promise<{ success: boolean }> => {
    const response = await api.post("/api/mates/read-all");
    return response.data;
  },

  // Remove a mate
  revokeMate: async (mateshipId: string): Promise<{ success: boolean }> => {
    const response = await api.post(`/api/mates/${mateshipId}/revoke`);
    return response.data;
  },

  // Send heartbeat (activity tracking)
  sendHeartbeat: async (): Promise<HeartbeatResponse> => {
    const response = await api.post("/api/users/heartbeat");
    return response.data;
  },

  // Get mate's latest workout
  getMateLatestWorkout: async (
    mateshipId: string
  ): Promise<MateLatestWorkoutResponse> => {
    const response = await api.get(`/api/mates/${mateshipId}/workouts/latest`);
    return response.data;
  },
};
